import Checkbox from '@mui/material/Checkbox';
import { useDispatch, useSelector } from 'react-redux';
import type { VoidFunctionComponent } from 'react';

import * as ProjectsV2Store from '../../../../redux/projectsV2';

/**
 * SelectAllProjectsCheckbox is the checkbox at the top of the UI
 * which is responsible for "bulk selecting" the projects.
 */
const SelectAllProjectsCheckbox: VoidFunctionComponent = () => {
  const dispatch = useDispatch();
  const checkboxState = useSelector(ProjectsV2Store.selectors.getBulkCheckboxState);
  return (
    <Checkbox
      className="projects-table__header__bulk-checkbox"
      indeterminate={checkboxState === 'indeterminate'}
      checked={checkboxState === 'checked'}
      onChange={() => dispatch(ProjectsV2Store.actions.toggleSelectAllOnPage())}
    />
  );
};

export default SelectAllProjectsCheckbox;
